import { Box, theme } from "@pallet-hq/hegel"
import { MiniCompanyProfile } from "@pallet/features/CompanyType/MiniCompanyProfile"
import { PostSection } from "./PostSection"
import { ActionRow } from "./ActionRow"
import { MiniTeamProfileFragment } from "__generated__/MiniTeamProfileFragment"

type MiniTeamProfileProps = {
    team: MiniTeamProfileFragment
    showPosts?: boolean
}

const MiniTeamProfile = ({ team, showPosts = true }: MiniTeamProfileProps) => {
    return (
        <Box
            width={["auto", "392px"]}
            display="flex"
            flexDirection="column"
            border={`0.75px solid ${theme.colors.gray300}`}
            borderRadius="12px"
            style={{ boxSizing: "border-box" }}
        >
            <Box
                display="flex"
                flexDirection="column"
                gridGap="small"
                p="small"
            >
                <MiniCompanyProfile company={team.company} />
                {showPosts && <PostSection postConnection={team.posts} />}
            </Box>
            <ActionRow team={team} />
        </Box>
    )
}

export { MiniTeamProfile }
